import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './style.scss';

// есть обычная кнопка с текстом внутри (внутри <span></span>), а может быть наоборот - кнопка
// внутри <span></span>
// обертка и содержимое могут быть разными компонентами.
// Это нужно для того, чтоб была еще особая кнопка variant="light", с возможностью сделать кликабельным
// только текст (пропы variant="light", textClick)

const ButtonComponent = ({ type, className, disabled, children, onClick, ariaLabel, variant }) => {
    return (
        <button
            type={type || 'button'}
            aria-label={ariaLabel}
            className={className}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

const SpanComponent = ({ className, children, onClick, disabled, theme }) => {
    const style = {
        color:
            theme && disabled ? theme.primaryDisabledColor : theme && !disabled ? theme.primaryColor : '#3377bb',
    };
    return (
        <span className={className} onClick={onClick} style={theme ? style : null}>
            {children}
        </span>
    )
};

function Button({ type, size, variant, onClick, disabled, children, className, textClick, ariaLabel, theme }) {
    const variantClass = `${variant ? ` ${variant}` : ''}`;
    const sizeClass = `${size === 'big' ? ' btn-big' : size === 'small' ? ' btn-small' : ''}`;
    const usersClassName = `${className ? ` ${className}` : ''}`;
    const textClickClass = `${variant === 'light' && textClick ? ' text-click' : ''}`;
    const mainClass = `button${sizeClass}${variantClass}${usersClassName}${textClickClass}`;
    // textClick - это параметр, который позволяет кликать только по тексту в кнопке
    const Wrap = textClick ? SpanComponent : ButtonComponent;
    const Inner = textClick ? ButtonComponent : SpanComponent;
    const wrapProps = { type, size, variant, disabled, className: mainClass, theme };

    return (
        <Wrap {...wrapProps} onClick={variant === 'light' && textClick ? null : onClick} ariaLabel={ariaLabel}>
            <Inner
                onClick={variant === 'light' && textClick ? onClick : null}
                disabled={disabled}
                ariaLabel={ariaLabel}
            >
                {children}
            </Inner>
        </Wrap>
        // <button
        //     type={type ? type : 'button'}
        //     className={mainClass}
        //     onClick={variant === 'light' && textClick ? null : onClick}
        //     disabled={disabled}
        // >
        //     <span onClick={variant === 'light' && textClick ? onClick : null} disabled={disabled}>
        //         {children}
        //     </span>
        // </button>
    );
}

Button.defaultProps = {
    variant: 'primary',
    size: 'small',
};

Button.propTypes = {
    type: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'light', 'light-bordered']),
    size: PropTypes.oneOf(['small', 'big']),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    textClick: PropTypes.bool,
    children: PropTypes.node,
    ariaLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
};

const mapStateToProps = (state) => ({
    theme: state.user.theme,
});

export default connect(mapStateToProps)(Button);



// WEBPACK FOOTER //
// ./src/components/button/index.js